import { Box } from "@mui/material";
import { useEffect } from "react";
import { useScopeOfWork } from "../context/ScopeOfWorkContext";
import { ScopeOfWorkStep } from "../context/scope-of-work.types";
import { ScopeOfWorkOrchestrator } from "./orchestrator/ScopeOfWorkOrchestrator";
import { PayloadDock } from "../../../preview/PayloadDock";

import { useMemo } from "react";

interface Props {
  onStepChange?: (step: ScopeOfWorkStep, isLastStep: boolean) => void;
  showControls?: boolean;
  debugJsonPayload: boolean;
  lockCategory?: boolean;
  showSummary?: boolean;
  job?: any;
  jobAlias?: string;
  setJobAlias?: (val: string) => void;
  jobDescription?: string;
  setJobDescription?: (val: string) => void;
}

export const ScopeOfWorkContent = ({
  onStepChange,
  showControls,
  debugJsonPayload,
  lockCategory = false,
  showSummary = false,
  job,
  jobAlias,
  setJobAlias,
  jobDescription,
  setJobDescription,
}: Props) => {
  const { state } = useScopeOfWork();

  const workflowOrder = useMemo(() => {
    const steps = [
      ScopeOfWorkStep.Categories,
      ScopeOfWorkStep.TypeOfPlaces,
      ScopeOfWorkStep.TypeOfService,
      ScopeOfWorkStep.Areas,
      ScopeOfWorkStep.Objects,
      ScopeOfWorkStep.SpecialRequests,
    ];
    if (showSummary) {
      steps.push(ScopeOfWorkStep.Summary);
    }
    return steps;
  }, [showSummary]);

  const currentIndex = workflowOrder.indexOf(state.step);
  const isLastStep = currentIndex === workflowOrder.length - 1;

  useEffect(() => {
    onStepChange?.(state.step, isLastStep);
  }, [state.step, isLastStep, onStepChange]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ScopeOfWorkOrchestrator
        lockCategory={lockCategory}
        showSummary={showSummary}
        job={job}
        jobAlias={jobAlias}
        setJobAlias={setJobAlias}
        jobDescription={jobDescription}
        setJobDescription={setJobDescription}
      />

      {debugJsonPayload && <PayloadDock payload={state} maxHeight={800} title="JSON Debug mode Scope Of Work" />}

      {showControls && (
        <Box
          sx={{
            borderTop: "1px solid var(--fx-surface-border, #E2E8F0)",
            p: 2,
          }}
        >
          {/* TODO ADD INTERN CONTROLS */}
        </Box>
      )}
    </Box>
  );
};
